import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { TmElement } from '../../custom-element.helper';

export class TmHighlightElement extends TmElement {
  @property({ type: String, reflect: true })
  highlight = '';

  public highlightString(value: string) {
    if (this.highlight.length > 0) {
      const hlValue = value.replace(
        new RegExp(this.highlight, 'gi'),
        '<span class="highlighted-text">$&</span>',
      );
      return html`<span>${unsafeHTML(hlValue)}</span>`;
    }

    return html`${unsafeHTML(value)}`;
  }
}
